import React from "react";
import SignRoutes from "./SignRoutes";

const AppRoutes = () => {
  return <SignRoutes/>;
};

export default AppRoutes;
